export enum WorkspaceInfoPanelTab {
  FileInfo = 'FileInfo',
  Comments = 'Comments',
  Activity = 'Activity',
  Versions = 'Versions',
}
